// React
import React from "react";
// React
// CSS
import styles from "./HelperHeader.module.css";
// CSS

type HelperHeaderProps = {
  absoluteText: string;
  className?: string;
  isBgWhite?: boolean;
};

const HelperHeader: React.FunctionComponent<HelperHeaderProps> = ({
  absoluteText,
  className,
  isBgWhite,
}) => {
  return (
    <div
      className={`${styles.helperTextContainer} ${className}  ${
        isBgWhite ? "before:bg-white" : "before:bg-beforeColor "
      }`}
      data-text={absoluteText}
    ></div>
  );
};

export default HelperHeader;
